export const IRP_MAP_ENABLED = 'IRP_MAP_ENABLED';
export const WHAT3WORDS = 'WHAT3WORDS';
export const ALERTS = 'ALERTS';
export const GOOGLE_RCS_PERMISSION = 'GOOGLE_RCS';

// Agent511 (Text-to-911)
export const AGENT_511 = 'AGENT_511';

// GIS Services
export const GIS_SERVICES = 'GIS_SERVICES';

export const INTELLIGENT_ANALYST_PERMISSION = 'RIA_DASHBOARD_API';

export const BETA_TEST_PERMISSION = 'BETA_TEST';

export const ZEROEYES = 'ZEROEYES';

export const FORD = 'FORD';

export const WHAT_3_WORDS = 'WHAT3WORDS';
